import { render, staticRenderFns } from "./voucherItem.vue?vue&type=template&id=2ba6964e&scoped=true&"
import script from "./voucherItem.vue?vue&type=script&lang=js&"
export * from "./voucherItem.vue?vue&type=script&lang=js&"
import style0 from "./voucherItem.vue?vue&type=style&index=0&id=2ba6964e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6964e",
  null
  
)

export default component.exports